<template>
  <section class="content">
    <div class="container-fluid">
		<div class="row">
            <div class="col-12">
                <h3 class="card-title">Detail Mutasi Masuk
                / ID Mutasi Masuk = {{ $route.query['barang_masuk_id'] }}</h3>
            </div>  
        </div>
        <div class="row">
            <div class="col-12" style="padding-bottom:10px;">
                <router-link
				  :to="{
					path: '/mutasi_masuk',
					query: { tahun: tahunMutasiMasuk }
				  }"
				>
					<i class="fa fa-arrow-left">&nbsp;Kembali</i>
				</router-link>
            </div>
        </div>
		
        <div class="row">
          <div class="col-12">        
            <div class="card">            
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <!--th>ID</th-->
                      <th>Rekening</th>
                      <th>Nama Barang</th>
                      <th>Qty</th>
                      <th style="text-align:right">Harga Satuan</th>
                      <th style="text-align:right">Total Harga</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="detailbarangmasuk in detailbarangmasuks.data" :key="detailbarangmasuk.id">
                        
                      <!--td>{{ruang.id}}</td-->
                      <td>{{detailbarangmasuk.kategori}}</td>
                      <td class="text-capitalize">{{detailbarangmasuk.nama_barang}}</td>
                      <td>{{detailbarangmasuk.qty}}</td>
                      <td align="right">{{returnRupiah(detailbarangmasuk.harga)}}</td>
                      <td align="right">{{returnRupiah(detailbarangmasuk.harga * detailbarangmasuk.qty)}}</td>
                    </tr>
                   
                    <tr>
                        <td colspan="4" style="font-weight:bold; text-align:center;">Grand Total</td>
                        <td style="font-weight:bold; text-align:right;">{{returnRupiah(grandtotal)}}</td>
                    </tr>

                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="detailbarangmasuks" @pagination-change-page="getResults"></pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>

    </div>
  </section>
</template>

<script>

 var get_barang_masuk_id = "";
 var totalHarga = 0;

    export default {
        data () {
            return {
                editmode: false,
                detailbarangmasuks : {},
                barangs : [],
                kategoris : [],
                grandtotal:0,
                form: new Form({
                    id : '',
                    barang_masuk_id: '',
                    barang_id: '',
                    kategori_barang_id: '',
                    nama_barang:'',
                    qty:'',
                    nama_satuan:'',
                    harga:'',
                }),
				tahunMutasiMasuk: null,
            }
        },
        methods: {
           returnAngkaFloat(e) {
                if (!/^[0-9\.]+$/.test(e.target.value)) {
                        if(e.target.value.substring(e.target.value.length-1) == ','){
                            e.target.value = e.target.value.substring(0,e.target.value.length-1) + ".";
                        }else{
                            e.target.value = e.target.value.substring(0,e.target.value.length-1);
                        }
                }
            },

			/*
            returnRupiah(val){
                var number_string = val.toString(),
                    split	= number_string.split('.'),
                    sisa 	= split[0].length % 3,
                    rupiah 	= split[0].substr(0, sisa),
                    ribuan 	= split[0].substr(sisa).match(/\d{1,3}/gi);
                    
                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }
                
                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                if(parseFloat(rupiah) == 0){
                    val = 0;
                }else{
                    val = rupiah;
                }
                
                return val;
            },*/
			returnRupiah(val){
				if(val === null || val === '' || val === undefined)
					return '0,00';

				return Number(val).toLocaleString('id-ID',{
					minimumFractionDigits:2,
					maximumFractionDigits:2
				});
			},

            getTotalHarga(){
                var txtQty = 0;
                var txtHargaSatuan = 0;

                txtQty = parseFloat($("#qty").val());
                txtHargaSatuan = parseFloat($("#harga").val());

                if(txtQty > 0 && txtHargaSatuan > 0){
                    totalHarga  = txtQty * txtHargaSatuan;
                }else{
                    totalHarga = 0;
                }

                $("#total_harga").val(returnRupiah(totalHarga));
            },

			sortRecords (index, tableName) {				
				this.sortIndex = index
				  this.showTable = tableName

				  this.sortDirection =
					this.sortDirection === 'asc' ? 'desc' : 'asc'

				  this.page = 1
				  this.getResults(1)
            },    
            changePageRange(){				  
				this.page = 1
				this.getResults(1)  
            },
			
            getResults(page = 1) {

                  this.$Progress.start();
                  
                  axios.get('/api/detail_mutasi_masuk?barang_masuk_id='+this.get_barang_masuk_id+'&page=' + page).then(({ data }) => (this.detailbarangmasuks = data.data.detail_barang_masuk, this.grandtotal = data.data.grand_total));

                  this.$Progress.finish();
            },

            loadDetailBarangMasuks(){
              
                    axios.get("/api/detail_mutasi_masuk?barang_masuk_id="+this.get_barang_masuk_id).then(({ data }) => (this.detailbarangmasuks = data.data.detail_barang_masuk, this.grandtotal = data.data.grand_total));
            },

        },
        mounted() {
            console.log('Component mounted.')
        },
        created() {
            let urlParams = new URLSearchParams(window.location.search);
           
            //this.get_barang_masuk_id =  window.location.href.split('=').pop();
            this.get_barang_masuk_id =  urlParams.get('barang_masuk_id');

            //alert(this.get_barang_masuk_id);

            this.$Progress.start();
            this.loadDetailBarangMasuks();
            this.$Progress.finish();
			
			this.tahunMutasiMasuk = this.$route.query.tahun
				  ? parseInt(this.$route.query.tahun)
				  : new Date().getFullYear()

        },
		watch: {
            searchTerm: function() {
                this.loadDetailBarangMasuks();
            }
        }
    }

    function returnRupiah(val){
                var number_string = val.toString(),
                    split	= number_string.split(','),
                    sisa 	= split[0].length % 3,
                    rupiah 	= split[0].substr(0, sisa),
                    ribuan 	= split[0].substr(sisa).match(/\d{1,3}/gi);
                    
                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }
                
                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                if(parseFloat(rupiah) == 0){
                    val = 0;
                }else{
                    val = rupiah;
                }
                
                return val;
            }

            function angkaFloat(e) {
                if (!/^[0-9\.]+$/.test(e.value)) {
                        if(e.value.substring(e.value.length-1) == ','){
                            e.value = e.value.substring(0,e.value.length-1) + ".";
                        }else{
                            e.value = e.value.substring(0,e.value.length-1);
                        }
                }
            }
</script>